/* Alpacas Foods — calculadora de frete da PDP (CEP → transportadora/prazo).
   Usa a Cart API (/cart/shipping_rates.json), que devolve a MESMA tarifa que o
   app de frete instalado (ex.: Frenet) calcularia no checkout — sem duplicar a
   regra de frete no tema, sem risco de o valor daqui divergir do cobrado depois.
   Desenvolvido por Hogrid — https://hogrid.com */
(function () {
  'use strict';

  /* Raiz da loja com barra final (mesmo padrão de assets/alp-cart.js): em
     Markets/idioma com prefixo de URL, caminho absoluto fixo retorna 404. */
  function root() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (r.charAt(r.length - 1) !== '/') r += '/';
    return r;
  }
  function cartUrl(path) { return root() + path; }

  function digits(v) { return (v || '').replace(/\D/g, ''); }

  /* A Cart API exige país e estado no endereço (senão devolve 422 pedindo
     cada um) — só o CEP não basta. Resolve o estado via ViaCEP (serviço
     público brasileiro, sem chave, CORS liberado): é o mesmo dado que
     qualquer checkout brasileiro pediria do cliente de qualquer forma. */
  function lookupCep(zip) {
    return fetch('https://viacep.com.br/ws/' + zip + '/json/', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (address) {
        if (!address || address.erro) throw new Error('cep');
        return address;
      });
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* /cart/shipping_rates.json devolve `price` como string em unidade cheia
     ("23.50"), diferente do resto da Cart API (cart.js usa centavos) — por
     isso a conversão manual antes de formatar. */
  function formatMoney(price, format) {
    var cents = Math.round(parseFloat(price) * 100) || 0;
    function group(value, thousands, decimal, places) {
      var parts = (value / 100).toFixed(places).split('.');
      var int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return places > 0 ? int + decimal + parts[1] : int;
    }
    var match = /\{\{\s*(\w+)\s*\}\}/.exec(format || '');
    if (!match) return (cents / 100).toLocaleString();
    var value;
    switch (match[1]) {
      case 'amount_no_decimals':                      value = group(cents, ',', '.', 0); break;
      case 'amount_with_comma_separator':             value = group(cents, '.', ',', 2); break;
      case 'amount_no_decimals_with_comma_separator': value = group(cents, '.', ',', 0); break;
      case 'amount_with_apostrophe_separator':        value = group(cents, "'", '.', 2); break;
      case 'amount_with_space_separator':             value = group(cents, ' ', ',', 2); break;
      case 'amount_no_decimals_with_space_separator': value = group(cents, ' ', ',', 0); break;
      default:                                        value = group(cents, ',', '.', 2); break;
    }
    return format.replace(match[0], value);
  }

  /* Quantidade selecionada no momento (radio de faixa marcado, ou o stepper
     padrão). O frete depende do peso total do pedido — usar sempre 1 unidade
     mostraria um valor mais barato do que o cliente vai efetivamente pagar.

     Os radios de faixa vivem dentro do <product-buy>, associados ao form via
     o atributo `form="alp-product-form"` — não são descendentes do <form> no
     DOM. Por isso a busca é global por [data-tier], como o próprio
     alp-product-buy.js faz (não dá pra escopar por `#alp-product-form ...`). */
  function selectedQty() {
    var checkedTier = document.querySelector('[data-tier]:checked');
    if (checkedTier) return parseInt(checkedTier.value, 10) || 1;
    var qtyInput = document.querySelector('[data-qty-input]');
    if (qtyInput) return parseInt(qtyInput.value, 10) || 1;
    return 1;
  }

  if (typeof customElements !== 'undefined' && !customElements.get('shipping-calculator')) {
    customElements.define('shipping-calculator', class extends HTMLElement {
      connectedCallback() {
        this.variantId = parseInt(this.dataset.variantId, 10);
        this.moneyFormat = this.dataset.moneyFormat || '';
        this.form = this.querySelector('[data-shipping-form]');
        this.input = this.querySelector('[data-shipping-cep]');
        this.button = this.querySelector('[data-shipping-submit]');
        this.errorEl = this.querySelector('[data-shipping-error]');
        this.ratesEl = this.querySelector('[data-shipping-rates]');
        this.noteEl = this.querySelector('[data-shipping-note]');
        this.spinnerEl = this.querySelector('.alp-shipping__spinner');
        if (!this.form || !this.variantId) return;

        this.input.addEventListener('input', function () {
          var d = digits(this.value).slice(0, 8);
          this.value = d.length > 5 ? d.slice(0, 5) + '-' + d.slice(5) : d;
        });

        this.form.addEventListener('submit', this.onSubmit.bind(this));
      }

      showError(message) {
        this.ratesEl.hidden = true;
        this.ratesEl.innerHTML = '';
        this.noteEl.hidden = true;
        this.errorEl.textContent = message;
        this.errorEl.hidden = false;
      }

      showRates(rates) {
        this.errorEl.hidden = true;
        if (!rates || !rates.length) {
          this.showError('Não encontramos opções de entrega para este CEP.');
          return;
        }
        this.noteEl.hidden = false;
        var format = this.moneyFormat;
        this.ratesEl.innerHTML = rates.map(function (rate) {
          return '<li class="alp-shipping__rate">' +
            '<span class="alp-shipping__rate-name">' + escapeHtml(rate.name) + '</span>' +
            '<span class="alp-shipping__rate-price">' + formatMoney(rate.price, format) + '</span>' +
            '</li>';
        }).join('');
        this.ratesEl.hidden = false;
      }

      onSubmit(e) {
        e.preventDefault();
        if (this.busy) return;
        var zip = digits(this.input.value);
        if (zip.length !== 8) {
          this.showError('Digite um CEP válido, com 8 números.');
          return;
        }

        this.busy = true;
        this.button.disabled = true;
        this.button.classList.add('is-loading');
        this.spinnerEl.classList.remove('hidden');
        this.errorEl.hidden = true;
        this.ratesEl.hidden = true;

        this.rates(zip)
          .then(this.showRates.bind(this))
          .catch(function (err) {
            if (err && err.message === 'cep') {
              this.showError('CEP não encontrado. Confira e tente novamente.');
            } else {
              this.showError('Não foi possível calcular o frete agora. Tente novamente em instantes.');
            }
          }.bind(this))
          .then(function () {
            this.busy = false;
            this.button.disabled = false;
            this.button.classList.remove('is-loading');
            this.spinnerEl.classList.add('hidden');
          }.bind(this));
      }

      /* A Cart API só calcula frete para o que está no carrinho — não existe
         endpoint de simulação isolada. Para reaproveitar a tarifa real do app
         de frete sem duplicar a regra: ajusta a linha do carrinho para a
         quantidade selecionada na tela, consulta a tarifa, e devolve a linha
         exatamente ao estado em que estava (nunca abre o drawer nem dispara os
         eventos de "adicionado ao carrinho" do restante do tema).

         /cart/change.js identifica a linha pelo `key` (formato
         "variant_id:hash"), não pelo ID de variante puro — passar só o ID
         devolve 400 ("expected Integer to be a ..."). */
      rates(zip) {
        var self = this;
        var qty = selectedQty();

        return lookupCep(zip).then(function (address) {
          return fetch(cartUrl('cart.js'), { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              var line = cart.items.filter(function (item) { return item.variant_id === self.variantId; })[0];
              var originalQty = line ? line.quantity : 0;
              var originalKey = line ? line.key : null;

              var ensure;
              if (originalQty === qty) {
                ensure = Promise.resolve(originalKey);
              } else if (originalQty === 0) {
                ensure = fetch(cartUrl('cart/add.js'), {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                  body: JSON.stringify({ id: self.variantId, quantity: qty })
                }).then(function (r) {
                  return r.json().then(function (data) {
                    if (!r.ok) throw new Error('add ' + r.status);
                    return data.key;
                  });
                });
              } else {
                ensure = fetch(cartUrl('cart/change.js'), {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                  body: JSON.stringify({ id: originalKey, quantity: qty })
                }).then(function (r) {
                  if (!r.ok) throw new Error('change ' + r.status);
                  return originalKey;
                });
              }

              return ensure.then(function (activeKey) {
                var params = new URLSearchParams();
                params.set('shipping_address[zip]', zip);
                params.set('shipping_address[country]', 'BR');
                params.set('shipping_address[province]', address.uf);

                return fetch(cartUrl('cart/shipping_rates.json') + '?' + params.toString(), { headers: { 'Accept': 'application/json' } })
                  .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
                  .then(function (result) {
                    var restore = originalQty === qty
                      ? Promise.resolve()
                      : fetch(cartUrl('cart/change.js'), {
                          method: 'POST',
                          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                          body: JSON.stringify({ id: activeKey, quantity: originalQty })
                        });
                    return restore.then(function () {
                      if (!result.ok) throw new Error('shipping_rates ' + result.ok);
                      return result.data.shipping_rates || [];
                    });
                  });
              });
            });
        });
      }
    });
  }
})();
